import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    formControl: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    formControlLabel: {
      color: 'black',
    },
    group: {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
    },
    inlineGroup: {
      flexGrow: 0,
    },
    radio: {
      marginLeft: theme.spacing(1),
    },
    checkbox: {
      marginLeft: theme.spacing(1),
    },
    stretch: {
      flexGrow: 1,
    },
    question: {
      minWidth: '100%',
      marginTop: theme.spacing(1),
    },
    scale: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-evenly',
      flexWrap: 'wrap',
    },
  };
};
